module.exports = {
	ENV: 'production',
	WEB: process.env.VUE_APP_WEB,
	API_BASE: 'https://yun.chvr.cn',
	DEPLOY: {
		name: '正式',
		host: '121.224.78.190',
		username: 'root',
		password: 'Vyb123!@',
		path_admin: '/www/wwwroot/yun.chvr.cn/front/admin',
		path_saas: '/www/wwwroot/yun.chvr.cn/front/saas',
		path_agent: '/www/wwwroot/yun.chvr.cn/front/agent',
		path_index: '/www/wwwroot/yun.chvr.cn/front/index',
		
	},
};
